import React from 'react'
import { 
  Action, 
  any, 
  async, 
  AsyncState, 
  IOWidget, 
  loadingAsyncState, 
  mk_widget, stateful 
} from 'widgets-for-react'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CustomBlockData } from '../types.mod'
import { Link } from 'react-router-dom'
import { 
  getVacancies, 
  VacancyResponse 
} from '../../../../wordpress/wordpress_vacancy_api'
import { loaderSVG } from '../../../utils/loader'


export type BSLVacancyOverviewBlockProps = {
  key?: string
}

type BSLVacancyOverviewBlockState = {
  vacancies: AsyncState<VacancyResponse[]>
}

export type BSLVacancyOverviewBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  title_classname: string
  list_classname: string
  item_classname: string
  item_link_classname: string
  item_label_classname: string
  item_title_classname: string
  item_title_text_classname: string
  item_text_classname: string
  clickable_primary_classname: string
}>

export function BSLVacancyOverviewBlock<customBlockData, extra_images>(
  props: BSLVacancyOverviewBlockProps,
  options?: { style?: BSLVacancyOverviewBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    stateful<BSLVacancyOverviewBlockState>()(s0 =>
      any<Action<BSLVacancyOverviewBlockState>>()([
        async<VacancyResponse[]>()(s0.vacancies).map(a => s1 => ({
          ...s1,
          vacancies: a(s1.vacancies)
        })),
        mk_widget({
          run: setState => (
            <div className="block">
              { s0.vacancies.kind === 'loaded' ?
                (
                  s0.vacancies.value.length === 0 ?
                    (
                      <h2 className="title--s list-item__title">
                        <span className="list-item__title-text">Er zijn op dit moment geen openstaande vacatures.</span>
                      </h2>
                    ) : (
                      <ul className="flex flex--3 grid grid--vacancies">
                        {s0.vacancies.value.map(vacancy => (
                          <li  className="flex-item grid-item" key={vacancy.id}>
                            <Link to={`/werken-bij/vacatures/${vacancy.slug}`} className="grid-item__link">
                              <div className="grid-item__content">
                                <h2 className="title--m grid-item__title">{vacancy.title.rendered}</h2>
                                { 
                                  vacancy.acf.hero_intro &&
                                    <div dangerouslySetInnerHTML={{ __html: vacancy.acf.hero_intro }} />
                                }
                                <span className="link-button list-item__faux-link grid-item__faux-link">Lees meer</span>
                              </div>
                              <div className="grid-item__figure">
                                <span className="grid-item__label">vacature</span>
                                {
                                  vacancy.acf.image ? (
                                    <img
                                      src={vacancy.acf.image.sizes.medium_large}
                                      alt={vacancy.acf.image_alt}
                                      className="grid-item__image"
                                    />
                                  ) : (
                                    <img
                                      src="/frontend/images/bsl-768x376.jpg"
                                      alt="Logo BSL"
                                      className="grid-item__image"
                                    />
                                  )
                                }
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )
                ) : (
                  <div>
                    <div className="svg-loader svg-loader--nobg">
                      {
                        loaderSVG()
                      }
                    </div>
                  </div>
                )
              }
            </div>
          )
        })
      ]).map(a => a(s0))
    )({
      vacancies: loadingAsyncState(() => getVacancies())
    }).map(a => s => s)
}
